// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const SERVER_FULL_NAME = "Modr\u00fd kon\u00edk";
export const SERVER_SLOGAN = "Str\u00e1nka pre mami\u010dky a bud\u00face mami\u010dky";
export const STROLLER_HOME_COPY = "Ko\u010d\u00edkop\u00e9dia je najv\u00e4\u010d\u0161ia encyklop\u00e9dia ko\u010d\u00edkov na svete - \u00e1no, na svete :-)";
export const STROLLER_NO_RESULTS = "Zatia\u013e nem\u00e1\u0161 ulo\u017een\u00e9 \u017eiadne ko\u010d\u00edky.";
export const STROLLEROPEDIA_BRANDS_LIST = "Zna\u010dky ko\u010d\u00edkov";
export const STROLLEROPEDIA_MORE_ARTICLES = "Zobraz \u010fal\u0161ie \u010dl\u00e1nky";
export const STROLLEROPEDIA_NEW_ARTICLES = "Nov\u00e9 \u010dl\u00e1nky";
export const STROLLERS_ASK_OUR_STROLLER_EXPERT = "STROLLERS_ASK_OUR_STROLLER_EXPERT";
export const STROLLERS_GOT_A_QUESTION = "STROLLERS_GOT_A_QUESTION";
export const STROLLERS_SEARCH_HOMEPAGE_BTN_TITLE = "N\u00e1jdi ko\u010d\u00edk pod\u013ea svojich predst\u00e1v";
export const STROLLER_STROLLEROPEDIA = "Ko\u010d\u00edkop\u00e9dia";
